import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const KEY = "digitalshop_cart_v1";
const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((cur) => {
      const existing = cur.find((i) => i.product_id === product.id);
      if (existing) {
        return cur.map((i) =>
          i.product_id === product.id ? { ...i, quantity: Math.min(20, i.quantity + qty) } : i
        );
      }
      return [...cur, {
        product_id: product.id,
        title: product.title,
        price: product.price,
        image_url: product.image_url,
        quantity: qty,
      }];
    });
    setIsOpen(true);
  };
  const remove = (product_id) => setItems((cur) => cur.filter((i) => i.product_id !== product_id));
  const setQty = (product_id, quantity) =>
    setItems((cur) => cur.map((i) => (i.product_id === product_id ? { ...i, quantity } : i)));
  const clear = () => setItems([]);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const subtotal = useMemo(
    () => items.reduce((s, i) => s + (Number(i.price) || 0) * i.quantity, 0),
    [items]
  );
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  const value = { items, add, remove, setQty, clear, isOpen, open, close, subtotal, count };
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be inside CartProvider");
  return ctx;
}
